export default "__VITE_ASSET__b79a024c__"